import { useMutation } from '@tanstack/react-query'
import { requestApi } from 'api/api'
import { BASE_API_URL } from 'constants/links'
import { CUSTOMER_AGREEMENTS_API, EmbeddedAgreementPayloadStatuses } from '../helpers/constants'
import { EmbeddedCustomerAgreementPayload } from '../helpers/types'

const submitCustomerPendingAgreements = ({
  reference,
}: EmbeddedCustomerAgreementPayload): Promise<void> => {
  return requestApi({
    baseUrl: BASE_API_URL,
    url: `${CUSTOMER_AGREEMENTS_API}/${reference}`,
    method: 'PUT',
    authenticated: false,
    data: { status: EmbeddedAgreementPayloadStatuses.SIGNED },
  })
}

export const useCustomerPendingAgreementsMutation = () => {
  return useMutation({ mutationFn: submitCustomerPendingAgreements })
}
